import { gsap } from "gsap";

// ---------------- Скрытие модального окна (оверлей + диалог)
/*
	Опции:
	 - duration (число) — длительность скрытия диалога
	 - overlayDuration (число) — длительность скрытия оверлея (по умолчанию короче диалога)
	 - ease (строка) — easing для диалога
	 - y (число) — конечное смещение по Y в px
	 - scale (число) — конечный масштаб диалога
	 - onComplete — после окончания таймлайна (удобно вызвать onClose)
*/
type HideModalOptions = {
	duration?: number;
	overlayDuration?: number;
	ease?: string;
	y?: number;
	scale?: number;
	onComplete?: () => void;
};

export const hideModal = (
	overlay: HTMLElement,
	dialog: HTMLElement,
	options: HideModalOptions = {},
) => {
	const {
		duration = 0.15,
		ease = "power2.in",
		y = 12,
		scale = 0.96,
		onComplete,
	} = options;

	const overlayDuration =
		options.overlayDuration ?? Math.max(duration * 0.65, 0.12);

	return gsap
		.timeline({ onComplete })
		.to(dialog, {
			opacity: 0,
			scale,
			y,
			duration,
			ease,
		})
		.to(
			overlay,
			{
				opacity: 0,
				duration: overlayDuration,
				ease: "power1.in",
			},
			0,
		);
};
